import { render, staticRenderFns } from "./Grafico1Valore.vue?vue&type=template&id=14d45b78&"
import script from "./Grafico1Valore.vue?vue&type=script&lang=js&"
export * from "./Grafico1Valore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports